import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { BaseComponent } from '../../../../common/components/base.component';
import { ModalService } from '../../../../common/services/modal.service';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { ShowInfoModalComponent } from '../../../hub/show.info.modal/show.info.modal.component';
import { InfoModalData, ShowInfoModalActions } from '../../../hub/show.info.modal/show.info.modal.provider';
import { SchedulerApiService } from '../../../../services/scheduler.api.service';

@Component({
  templateUrl: './event.pulling.status.modal.component.html',
  styleUrls: ['./event.pulling.status.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EventPullingStatusModalComponent extends BaseComponent {
  public loading = false;
  public formGroup: FormGroup;
  public eventbrite: string[] = [];
  public serpGoogle: string[] = [];

  constructor(
    private fb: FormBuilder,
    private accountApiService: AccountApiService,
    private alertify: AlertifyService,
    private formBuilder: FormBuilder,
    private modalService: ModalService,
    private schedulerApiService: SchedulerApiService,
    private dialogRef: MatDialogRef<EventPullingStatusModalComponent>,
  ) {
    super();
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      googleKey: [null, null],
      blockCategories: [null, null],
    });

    this.loading = true;
    this.schedulerApiService.eventPullingStatus().subscribe((data) => {
      this.eventbrite = data.map((x) => {
        return `${x.hubName} - ${new Date(x.eventbrite.lastRunTime).toLocaleString()}`;
      });

      const sortedBySerpGoogle = data.sort((a, b) => a.serpGoogle.lastRunTime - b.serpGoogle.lastRunTime);

      this.serpGoogle = sortedBySerpGoogle.map((x) => {
        return `${x.hubName} - ${new Date(x.serpGoogle.lastRunTime).toLocaleString()}`;
      });

      console.log(this.serpGoogle);
    });
  }


  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/event.pulling.status/event.pulling.status.modal.component.ts